import { Category, toCategory } from '#~/hot-keys/index.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useHotKeysCategoryPref = (): UsePrefState<Category> =>
  usePrefState('account.hot-keys.category', Category.Essentials, {
    deserialize: toCategory
  });
